import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { getOfficeLocations } from '../../actions/userActions/officelocationAction'
import Loader from '../subComponents/Loader'
import ServerSideSearch from '../subComponents/search/ServerSideSearch'
import Pagination from '../paginatioin/pagination'
import './OfficeLocation.css'
import AddButton from '../subComponents/buttons/AddButton'
import { IconButton, Tooltip } from "@mui/material";
import EditButton from '../subComponents/buttons/EditButton'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CustomButton from '../subComponents/buttons/CustomButton'
import DynamicTable from '../reuse_components/DynamicTable'
import CustomPagination from '../subComponents/pagination/CustomPagination'
import SearchInput from '../subComponents/search/SearchInput'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import Heading6Regular from '../designSystem/Heading6Regular'

import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import thIcon from "../../assets/images/thIcon.svg";
import AddOfficeLocations from './AddOfficeLocations'
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector'
import LoadingOverlay from '../loadingOverlay/LoadingOverlay'
import { t } from '../../locales/translate'

function OfficeLocations() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(1);
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [OfficeLocationsData, setOfficeLocationsData] = useState([]);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const [selected, setSelected] = useState({
    textSearch: '',
  })
  const [filters, setFilters] = useState({
    textSearch: '',
  })
  useEffect(() => {
    dispatch(getOfficeLocations(body))
  }, [currentPage, filters])

  const officeLocations = useSelector(
    (state) => state.officeLocations_reducer.officeLocations,
  )
  const isLoading = useSelector((state) => state.officeLocations_reducer.isOfficeLocationsLoading);
  const totalPages = officeLocations?.totalPages || 0;
  const totalItems = officeLocations?.totalCount || 0;
  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const body = {
    filter: filters,
    pageNumber: currentPage,
    pageSize: itemsPerPage,
  }
 const handleSearch = (e) => {
    setSelected({ ...selected, ['textSearch']: e.target.value })
    if (e.target.value.length >= 1) {
      setTimeout(() => {
        setFilters({ ...filters, ['textSearch']: e.target.value })
      }, 500)
    }
    if (e.target.value == '') {
      setFilters({ ...filters, ['textSearch']: e.target.value })
    }
  }
  const handleAddOfficeLocationClick = () => {
    setEditData(null);
    setShowModal(true);
  };


  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getOfficeLocations(body));
    setShowModal(false);
  };
  useEffect(() => {
    const officeLocationData = officeLocations && officeLocations.result?.[0]?.officeLocations || [];
    const OfficeLocationData = officeLocationData?.map((officeLocations) => ({
      ...officeLocations,
      isHeadOffice: officeLocations.isHeadOffice ? "Yes" : "No",
    }));

    setOfficeLocationsData(OfficeLocationData);
  }, [officeLocations]);
  console.log(totalItems, 'items');

  const columns = [
    { label: `${t("address")}`, accessor: "address" },
    { label: `${t("city")}`, accessor: "cityName" },
    { label: `${t("contact")}`, accessor: "contact1" },
    { label: `${t("headOffice")}`, accessor: "isHeadOffice" },
  ];
  const handleEditOfficeLocation = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  const actions = [
    {
      label: 'Edit OfficeLocation',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdateOfficeLocation',
      handler: handleEditOfficeLocation,
    },
  ];
  const handleItemsPerPageChange = (value) => {
    const body = {
      filter: filters,
      pageNumber: firstPage,
      pageSize: value,
    }
    dispatch(getOfficeLocations(body));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
        <div className="main-container">
           <div className="content-wrapper">
            <div className="pagination">
              <SearchInput
                placeholder="Search"
                onChange={handleSearch}
                value={selected.textSearch}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ minWidth: '80px', marginRight: '10px' }}>
            <ItemsPerPageSelector
               value={itemsPerPage}
                 onChange={handleItemsPerPageChange}
              />
            </div>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />

                {permissions && permissions.includes("CanAddOfficeLocation") && (
                  <CustomButton text={t("addNew")} onClick={handleAddOfficeLocationClick} />
                )}
              </div>
            </div>
            </div>

            <DynamicTable
              data={OfficeLocationsData}
              columns={columns}
              permissions={permissions}
              actions={actions}
              thIcon={thIcon}
              showPagination={totalItems > 0}
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>
        {showModal && (
          <AddOfficeLocations
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div>

    </>
  );
}

export default OfficeLocations
